import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./SignupPage.css";
import { Link } from 'react-router-dom';
import { FcGoogle } from "react-icons/fc";
import { BsMicrosoft } from "react-icons/bs";
import { Button } from 'react-bootstrap';

const SignupPage = ({ onSignup, buttonText = "Continue", redirectTo = "/CreateCompanyProfileSearch" }) => {
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [error, setError] = useState("");

    const handleSubmit = (event) => {
        event.preventDefault();
        if (password !== confirmPassword) {
            setError("Passwords do not match");
            return;
        }
        setError("");
        onSignup({ name, email, password });
    };

    return (
        <div className="js-pg-hg mt-5">
        <div className="d-flex mt-5 align-items-center sign-bg justify-content-center">
            <form onSubmit={handleSubmit} className="signup-container shadow-sm">
                <div className="form-header text-center mb-4">
                    <h2>Create your account</h2>
                    <p>You can sign in or sign up here</p>
                </div>

                <div className="mb-4">
                    <div className="input-group">
                        <span className="input-group-text"><i className="bx bxs-user"></i></span>
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Full Name"
                            required
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                        />
                    </div>
                </div>

                <div className="mb-4">
                    <div className="input-group">
                        <span className="input-group-text"><i class='bx bxs-envelope' ></i></span>
                        <input
                            type="email"
                            className="form-control"
                            placeholder="Work Email Address"
                            required
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                        />
                    </div>
                </div>

                <div className="mb-4">
                    <div className="input-group">
                        <span className="input-group-text"><i className="bx bxs-lock"></i></span>
                        <input
                            type="password"
                            className="form-control"
                            placeholder="Set Password"
                            required
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                        />
                    </div>
                </div>

                <div className="mb-4">
                    <div className="input-group">
                        <span className="input-group-text"><i className="bx bxs-lock"></i></span>
                        <input
                            type="password"
                            className="form-control"
                            placeholder="Confirm Password"
                            required
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                        />
                    </div>
                    {error && <small className="text-danger">{error}</small>}
                </div>


                <Button href={redirectTo} className="btn btn-primary w-100 py-3">
                    {buttonText}
                </Button>





                <div className="text-center my-3">
                    <span>or sign up with</span>
                </div>

                <div className="d-flex flex-column gap-3">
                    <button type="button" className="btn social-btn d-flex align-items-center justify-content-center p-3 w-100 border border-secondary text-dark">
                        <FcGoogle className="me-2" size={20} /> Continue with Google
                    </button>
                    <button type="button" className="btn social-btn d-flex align-items-center justify-content-center p-3 w-100 border border-secondary text-dark">
                        <BsMicrosoft className="me-2 text-primary" size={20} /> Continue with Microsoft
                    </button>
                </div>

                <div className="text-center mt-4">
                    <p className="p-0 m-0">Already have an account?<Button variant="btn-primary" as={Link} to="/LoginPage" className="px-2 text-primary text-decoration-none">Login</Button></p>
                </div>
            </form>
        </div>
        </div>
    );
};

export default SignupPage;